import React from "react";
import PropTypes from "prop-types";
import { H1, P } from "orcs-design-system";

import icons from "src/config/icons";
import { useAllocationConfig } from "src/contexts/global/WorkspaceContext/WorkspaceContext";

import { copywriting } from "./ErrorPage.config";
import ErrorPageWrapper from "./ErrorPageWrapper";

const GroupAccessUnauthorizedError = ({
  errTitleOverride,
  errDescOverride,
}) => {
  const allocationConfig = useAllocationConfig();

  const {
    groupAccessUnauthorisedTitle,
    groupAccessUnauthorisedDescription,
    groupAccessUnauthorisedShowBackButton,
    groupAccessUnauthorisedShowSupportButton,
    groupAccessUnauthorisedShowLogoutButton,
  } = allocationConfig;

  const title =
    errTitleOverride ||
    groupAccessUnauthorisedTitle ||
    copywriting.defaultGraphQLUnauthorizedErrorHeading;

  const description =
    errDescOverride ||
    groupAccessUnauthorisedDescription ||
    copywriting.defaultGraphQLUnauthorizedErrorDetail;

  return (
    <ErrorPageWrapper
      icon={icons.lock}
      clientInfo={false}
      showHeader={false}
      showContainer={false}
      showBackButton={groupAccessUnauthorisedShowBackButton}
      showSupportButton={groupAccessUnauthorisedShowSupportButton}
      showLogoutButton={groupAccessUnauthorisedShowLogoutButton}
    >
      <H1>{title}</H1>
      <P>{description}</P>
    </ErrorPageWrapper>
  );
};

GroupAccessUnauthorizedError.propTypes = {
  errTitleOverride: PropTypes.string,
  errDescOverride: PropTypes.string,
};

export default GroupAccessUnauthorizedError;
